import axios from "src/lib/axios";
import { AppSetting } from "./Types/AppSetting";
import { Language } from "./Types/Language";
import { Currency } from "./Types/Currency";
import { InitLoadWidget } from "./Types/InitLoadWidget";
import { CategoryMasterType, DateWindowMasterType, ReadStatusMasterType } from "./Types/MasterTypes";
import AlertMessage from "src/components/ui-components/AlertMessage";

const API_URLS = {
  GET_APP_SETTING: `/AppSettings/GetAppSetting`,
  GET_LANGUAGES: '/Language/GetLanguages',
  GET_CURRENCIES: '/Currencies/GetCurrencies',
  GET_INIT_LOAD_WIDGETS: '/Widget/GetInitLoadWidgets',
  GET_DATE_WINDOW_MASTER: '/DateWindowMaster',
  GET_READ_STATUS_MASTER: '/ReadStatusMaster',
  GET_CATEGORY_MASTER: '/CategoryMaster',
  INSERT_UPDATE_APP_SETTING: '/AppSettings/InsertUpdateAppSetting',
  GET_PAGE_GROUPS_AND_PAGES: `/MenuAndSubMenu/GetPageGroupsAndPagesForAppKey`,
  GET_VOICENAV_SHAPES: `/AppSettings/GetVoiceNavShapes`,
};

export const getAppSetting = async () => {
  try
  {
    const appSetting = await axios.get<AppSetting>(API_URLS.GET_APP_SETTING);
    return appSetting.data;
  } catch {
    return null;
  }
};

export const getLanguagesForAppKey = async (): Promise<any> => {
  try {
    const response = await axios.get<Language[]>(API_URLS.GET_LANGUAGES);
    return response?.data  || [];
  } catch {
    return [];
  }
};

export const getCurrencies = async (): Promise<any> => {
  try {
    const response = await axios.get<Currency[]>(API_URLS.GET_CURRENCIES);
    return response?.data || [];
  } catch {
    return [];
  }
};

export const getInitLoadWidgets = async () => {
  try {
    const response = await axios.get<InitLoadWidget[]>(API_URLS.GET_INIT_LOAD_WIDGETS);
    return response?.data || [];
  } catch {
    return [];
  }
};

export const getDateMaster = async () => {
  try {
    const response = await axios.get<DateWindowMasterType[]>(API_URLS.GET_DATE_WINDOW_MASTER);
    return response?.data || [];
  } catch {
    return [];
  }
};

export const getReadStatusMaster = async () => {
  try {
    const response = await axios.get<ReadStatusMasterType[]>(API_URLS.GET_READ_STATUS_MASTER);
    return response?.data || [];
  } catch {
    return [];
  }
};

export const getCategoryMaster = async () => {
  try {
    const response = await axios.get<CategoryMasterType[]>(API_URLS.GET_CATEGORY_MASTER);
    return response?.data || [];
  } catch {
    return [];
  }
};

export const insertUpdateAppSetting = async (appSettingsData): Promise<any> => {
  try
  {
    const res = await axios.post(API_URLS.INSERT_UPDATE_APP_SETTING, appSettingsData);
    AlertMessage({ type: 'success', msg: res?.data?.message || 'Application settings updated successfully'});
    return res?.data?.isSuccess;
  } catch(err) {
    Object.entries(err.errors).forEach(([, errMsg]: any) => {
      AlertMessage({ type: 'error', msg: errMsg.errorMessage });
    });
    return false;
  }
};

export const getPageGroupsAndPages = async () => {
  try {
    const response = await axios.get(API_URLS.GET_PAGE_GROUPS_AND_PAGES);
    return response?.data || [];
  } catch {
    return [];
  }
};
export const 
getVoiceNavShapes = async () => {
  try {
    const response = await axios.get(API_URLS.GET_VOICENAV_SHAPES);
    return response?.data || [];
  } catch {
    return [];
  }
};